var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJuniorHomme(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "74px",
    height: "82px",
    viewBox: "0 0 74 82",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "JuniorHomme") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "JuniorHomme",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F4A76E",
    cx: 24.5,
    cy: 43.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F4A76E",
    cx: 26.5,
    cy: 40.5,
    r: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(9.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.8192398,-0.350639523 C32.76131,-0.350639523 36.1176709,0.323709306 38.0070141,1.49753893 C38.2693517,1.1027888 38.5021619,0.784714062 38.7043026,0.542460998 C38.9307624,0.271063083 39.1335816,0.0786915377 39.3028411,-0.0458665197 C41.2696013,-0.695780728 40.9523202,-0.0627584545 41.0500938,0.0471481754 C41.155465,0.165595175 41.2556153,0.323262732 41.3265621,0.535149087 C41.3914397,0.728909732 41.4385913,1.00497846 41.4385913,1.36953463 C43.7875806,0.716752305 45.0357309,0.518561689 45.3383754,0.65917425 C45.6257577,0.79269584 45.7771771,0.989205331 45.8677948,1.18744348 C45.9666519,1.40370619 46.0071882,1.65869321 45.9122024,1.95897996 C45.866152,2.10456306 45.7623999,2.31272373 45.5374794,2.53379215 C45.3472343,2.72077905 44.9951998,2.98144032 44.593248,3.26973913 C44.3134494,3.47042395 44.0032843,3.68906196 43.7324527,3.9087713 C46.435521,5.4377636 48.082198,8.07682002 49.0275825,11.0447511 C50.8320768,16.7097637 50.0409694,23.5214949 49.8550492,24.9445869 C50.2272778,25.9418094 50.415977,27.3278888 50.2187387,28.7867429 C50.0230068,30.2344549 49.4841009,31.507082 48.7590183,32.4583268 C48.1041364,33.3174745 47.2974309,33.9146349 46.442077,34.1993224 C44.849552,39.6293744 41.3046864,44.0148693 36.7879825,46.2904498 L36.7879825,46.2904498 L36.7878913,47.9489635 C42.5764677,48.9905614 47.5584878,51.39585 51.2262109,54.6696147 C55.4381602,58.429149 57.9235787,63.3323079 57.9742854,68.6642408 L57.9742854,68.6642408 L-0.187575484,69.0058461 C-0.415308353,62.3526035 2.85034414,57.106479 8.4023842,53.0428143 C11.8416347,50.5255485 16.1395779,48.6331019 20.9497322,47.6313772 L20.9497322,47.6313772 L20.9294004,45.3753898 C17.2127618,42.9638572 14.322812,39.0467652 12.9076703,34.3334096 C11.7711903,34.2112366 10.7649416,33.6422839 9.97768828,32.7432611 C9.06144763,31.6969381 8.4482747,30.1838546 8.33215063,28.4578562 C8.2638404,27.4422486 8.37499819,26.4733995 8.62448153,25.6117348 C6.31641316,18.2187625 7.7413249,12.5185643 10.7648039,8.35952113 C15.0769076,2.42786896 22.7448138,-0.350639523 27.8192398,-0.350639523 Z",
    id: "Combined-Shape",
    stroke: "#F6F6F6",
    strokeWidth: 2,
    fill: "#E3B392"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7874015,44.375 L35.7878447,48.7954447 C47.820028,50.9678266 56.4753178,58.6969702 56.9541068,68 L56.9541068,68 L0.804853094,68 C0.804853094,62.4231489 3.90962887,57.7553061 8.99300743,54.1006278 C12.5086172,51.5730916 16.9517588,49.7124014 21.9238731,48.8050997 L21.9245631,44.375 L35.7874015,44.375 Z",
    id: "Combined-Shape",
    fill: "#E3B392"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6551807,8.5 C37.4177687,8.5 43.943565,14.6027947 45.8173529,22.8723979 C45.990054,22.8620635 46.1645413,22.8690103 46.3394885,22.8945652 C48.3253651,23.1847234 49.6184884,25.7627387 49.2277549,28.6527611 C48.8840833,31.1946952 47.3522175,33.1313622 45.6369173,33.3636254 C43.5526586,41.2562978 37.1859287,47 29.6551807,47 C22.1190214,47 15.7485536,41.2480403 13.6687691,33.3456272 C13.5506715,33.3721989 13.4297285,33.3899525 13.3067542,33.398892 C11.3062561,33.5442959 9.52576867,31.3020766 9.32989629,28.3907474 C9.13407869,25.4794143 10.5970386,23.0014331 12.5975354,22.85601 C12.8970809,22.8342379 13.1916936,22.8659979 13.4767923,22.9455209 C15.3278082,14.6393206 21.8693974,8.5 29.6551807,8.5 Z",
    id: "Combined-Shape",
    fill: "#F4C6A3"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F4A76E",
    cx: 18.5,
    cy: 34.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F4A76E",
    cx: 19.5,
    cy: 31.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F4A76E",
    cx: 22.5,
    cy: 31.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F4A76E",
    cx: 21.5,
    cy: 35.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F4A76E",
    cx: 35.5,
    cy: 32.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F4A76E",
    cx: 37.5,
    cy: 31.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F4A76E",
    cx: 37.5,
    cy: 34.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F4A76E",
    cx: 39.5,
    cy: 32.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9765648,68 C44.9114549,68 54.2525999,68 57,68 C56.5225681,58.3127736 47.893252,50.2641422 35.8963635,48 C35.7878788,49.2438441 37.5463932,52.8370369 29.1916702,53.524053 C20.8369473,54.2110691 22.0960936,49.8559324 22.0960936,48.0025432 C17.1237699,48.945147 12.6804793,50.8857942 9.16638891,53.524053 C4.09652279,57.330335 1,62.1918095 1,68 C4.54726182,68 13.8727834,68 28.9765648,68 Z",
    id: "Oval",
    fill: "#208AB0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Yeux",
    transform: "translate(19.000000, 23.000000)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#303030",
    cx: 2.15909091,
    cy: 2,
    rx: 2.15909091,
    ry: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#F2F2F2",
    cx: 1.72727273,
    cy: 1.6,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#303030",
    cx: 16.8409091,
    cy: 2,
    rx: 2.15909091,
    ry: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#F2F2F2",
    cx: 16.4090909,
    cy: 1.6,
    rx: 1,
    ry: 1
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.22201241,25.4872074 C3.52702827,7.83261759 19.1244849,0.00349466449 27.4517902,0.00349466449 C33.0033271,0.00349466449 36.5122402,0.787064985 37.9785295,2.35420563 C38.9561356,0.724266084 39.6070115,-0.0593042364 39.9311574,0.00349466449 C40.2553033,0.0662935654 40.2553033,0.975962352 39.9311574,2.73250102 C42.7822752,1.38228617 44.3683204,0.782080785 44.6892929,0.931884874 C45.1707518,1.15659101 41.7890172,2.82507021 42.005919,3.70083229 C51.3470363,7.57554464 48.6335749,24.6075924 48.6335749,24.7403709 C48.0573687,23.7312084 46.8113651,23.2929353 44.8955639,23.4255515 C43.7198543,27.5199164 42.7566394,29.2788228 42.005919,28.702271 C42.5551834,26.2911733 43.7837352,23.7837403 41.0894455,20.5024593 C37.8978922,21.2988091 33.890327,18.7793595 29.0667499,12.9441106 C26.8253037,14.6631001 26.6204224,17.4902872 28.4521059,21.4256721 C25.1402815,21.9386694 23.2171008,19.4564626 22.6825638,13.9790519 C20.8854661,15.1593985 20.1477483,17.3338677 20.4694105,20.5024593 C19.1639681,20.2502981 18.3091949,19.0140873 17.9050911,16.7938269 C15.9201396,21.6745839 15.5763151,26.0190269 16.8736176,29.8271557 C16.3964689,30.6147592 15.2618546,28.7106948 13.4697746,24.1149625 C11.9560024,22.9227017 10.5400817,23.3801167 9.22201241,25.4872074 Z",
    id: "Path-13",
    fill: "#3F2820"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5,34 C29.7886644,34 30.9553311,33.3333333 32,32 C30.9553311,32.2879848 29.7886644,32.4319772 28.5,32.4319772 C27.2113356,32.4319772 26.0446689,32.2879848 25,32 C26.0446689,33.3333333 27.2113356,34 28.5,34 Z",
    id: "Oval",
    fill: "#F4A76E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29,39 C31.5773288,39 33.9106622,38 36,36 C33.9106622,37.0742349 31.5773288,37.6113523 29,37.6113523 C26.4226712,37.6113523 24.0893378,37.0742349 22,36 C24.0893378,38 26.4226712,39 29,39 Z",
    id: "Oval",
    fill: "#F4A76E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.780466,49.0844847 C21.275275,51.9760721 23.7641292,53.3170586 27.4239791,53.1879533 L28.3697307,53.1296097 C32.8260971,52.7496409 35.9930791,51.2234916 35.9208033,49 L37.9782796,49.3599492 C38.2448188,53.1743431 36.0725266,54.8393368 30.6720151,55.4165229 C30.4425768,55.4410444 28.827187,60.9796869 28.5912095,60.999904 C28.2827469,61.0261082 27.9886864,55.6767719 27.6942359,55.6891802 C22.3991294,55.9123193 19.4080012,53.882455 20.098224,49.3599492 L21.780466,49.0844847 Z",
    id: "Path-14",
    fill: "#F6F6F6",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJuniorHomme);
export default __webpack_public_path__ + "static/media/JuniorHomme.750b8666602f0f2e394b1221009e80e9.svg";
export { ForwardRef as ReactComponent };